import { render, staticRenderFns } from "./cider_footer.vue?vue&type=template&id=04582d27&scoped=true"
import script from "./cider_footer.vue?vue&type=script&lang=js"
export * from "./cider_footer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04582d27",
  null
  
)

export default component.exports